import React, { FunctionComponent, ReactNode } from 'react';
import { ButtonProps } from '@lyse-as/formds-react';

import { ProductDetails } from 'src/components/product-details';
import { useSelectIsEligibleToPurchase } from 'src/hooks/use-select-is-eligible-to-purchase';
import { OrderStep } from 'src/state/order/types';
import { i18n } from 'src/i18n';
import { useSelectUpgradeDecoderOrThrow } from 'src/hooks/use-select-upgrade-decoder';

interface Props {
  content: ReactNode;
  buttonProps: ButtonProps;
}

export const Upgrade: FunctionComponent<Props> = (props) => {
  const { onceOnlyPrice } = useSelectUpgradeDecoderOrThrow();
  const purchaseAllowed: boolean = useSelectIsEligibleToPurchase();
  const purchaseLink = purchaseAllowed
    ? {
        productDetailsPage: OrderStep.PURCHASE_DECODER,
        text: i18n.page.upgrade.linkText,
      }
    : undefined;

  return (
    <ProductDetails
      title={i18n.page.upgrade.title}
      mainPrice={{
        price: onceOnlyPrice,
        text: i18n.page.upgrade.mainPriceText,
      }}
      secondaryPrice={{
        text: i18n.page.upgrade.secondaryPriceText,
      }}
      link={purchaseLink}
      showReturnNote={true}
      {...props}
    />
  );
};
